import component from './SheetSamplesList.vue'
export default component
